<div [class.catalog]="catalog" [class.notCatalog]="!catalog" i18n-data-th="@@AddToCart" data-th="В корзину">

  <div class="cart-table">
    <div class="cart-table__top">
      <div class="cart-table__block-count_parent">
        <div class="cart-table__block-count">

          <div class="cart-table__count">
            <button class="down-arrow__click pointer" (click)="decrease()" (keydown)="onKeyDown($event)">
              <tui-icon icon="minus"/>
            </button>

            <input nbInput [formControl]="inputFormControl" (keydown)="onKeyDown($event)" (input)="manualChange()" pattern="^\d+(\.\d{1,2})?$" inputmode="numeric" [decimal]="true" digitOnly [class.withUnit]="product.unitHeader">
            <button class="up-arrow__click pointer" (click)="increase()" (keydown)="onKeyDown($event)">
              <tui-icon icon="plus"/>
            </button>
          </div>
          @if (product.unitHeader) {
            <div class="cart-table__pieces">
              <p>{{ product.unitHeader }}</p>
            </div>
          }
        </div>

        @if (multiplicityOrder > 1 && inCart === 0) {
          <div class="packaging">{{ translations.packageBy | lowercase }} {{ multiplicityOrder }} {{ product.unitHeader }}</div>
        }
        @if (inCart > 0) {
          <div class="packaging"><strong>{{ inCart }}</strong> {{ translations.inCart }}</div>
        }
      </div>

      <div class="cart-table__add">
        <button nbButton status="primary" (click)="addToCart()">
          <tui-icon icon="shopping-cart"/>
          @if (!catalog) {
            <span i18n="@@AddToCart">Добавить в корзину</span>
          }
        </button>

        @if (!catalog) {
          @if (!authService.isAnonymous()) {
            <button nbButton (click)="showSpecificationPopup()" i18n="@@AddToSpecification">
              В спецификацию
            </button>
          }
        }

      </div>
    </div>
  </div>
</div>
